import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import { FrontPage } from "../../pages/FrontPage/FrontPage";
import { GameCreator } from "../../pages/Game/GameCreator/GameCreator";
import { GamePlayer } from "../../pages/Game/GamePlayer/GamePlayer";
import { RoutesContainer } from "./RoutesContainer/RoutesContainer";
import { RouteError } from "../../components/RouteError/RouteError";

interface IProps {

}

export function Router(props: IProps) {
    return (
        <HashRouter>
            <RoutesContainer>
                <Routes>
                    <Route path="/" element={<FrontPage />} />
                    <Route path="/game-creator" element={<GameCreator />} />
                    <Route path="/game" element={<GamePlayer />} />
                    <Route path='*' element={<RouteError />} />
                </Routes>
            </RoutesContainer>
        </HashRouter>
    )
}
